import nxModule from 'nxModule';
import LocalCache from 'shared/utils/localCache';

nxModule.factory('permissionCache', (http, CacheFactory, config) =>
  new LocalCache({
    provider: () => http.get(`/management/permissions`),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.permissionCache,
    cacheName: 'permissionCache'
  })
);
